import ContentPage from './Content';

export const Content = () => <ContentPage />;
